(() => {
  if (window.howCatalogReady) return;
  window.howCatalogReady = true;
  document.addEventListener('change', event => {
    const sort = event.target.closest('[data-how-sort]');
    if (sort && sort.form) sort.form.requestSubmit();
  });
  const preview = target => {
    const swatch = target.closest('[data-how-preview]');
    if (!swatch) return;
    const card = swatch.closest('[data-how-card]');
    const image = card?.querySelector('.how-card__photo');
    if (!image) return;
    if (!image.dataset.originalSrc) {
      image.dataset.originalSrc = image.src;
      image.dataset.originalSrcset = image.srcset;
      image.dataset.originalAlt = image.alt;
    }
    image.removeAttribute('srcset');
    image.src = swatch.dataset.howPreview;
    image.alt = swatch.dataset.howPreviewAlt || '';
  };
  document.addEventListener('pointerover', event => preview(event.target));
  document.addEventListener('focusin', event => preview(event.target));
  const restore = (event) => {
    const card = event.target.closest('[data-how-card]');
    if (!card || card.contains(event.relatedTarget)) return;
    const image = card.querySelector('.how-card__photo');
    if (!image?.dataset.originalSrc) return;
    image.src = image.dataset.originalSrc;
    image.srcset = image.dataset.originalSrcset;
    image.alt = image.dataset.originalAlt;
  };
  document.addEventListener('pointerout', restore);
  document.addEventListener('focusout', restore);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const filters = event.target.closest('.how-catalog__filters[open]');
    if (filters) { filters.open = false; filters.querySelector('summary').focus(); }
  });
})();
